import Axios from "axios"


export async function get_grade_list(props) {
    const Set_gradeList = props['Set_gradeList']
    const isMounted = props['isMounted']

    const result = await Axios.post("/damo/grade")
    const data = result['data']

    if(data['status'] === 'fail') {
        alert(data['message'])
    }
    else if(data['status'] === 'success') {
        await Set_gradeList(data['data'])

        if(isMounted) {
            isMounted.current++
        }
    }
}